module.exports = __webpack_public_path__ + "static/img/service2.c60e87f2.png";